import React, { useState } from 'react';
import Slider from "react-slick";
import Product from '../../Home/products/Product';
import data from '../../Home/products/FakeProduct';
// import { VscChevronLeft, VscChevronRight } from "react-icons/vsc";
// import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { useGetProductsBySearchMutation } from '../../../features/api/apiSlice';
import { useEffect } from 'react';
import ProductCardLoader from '../../ui/loaders/ProductCardLoader';
import { useSelector } from 'react-redux';

function SampleNextArrow(props) {
    const { onClick } = props;

    return (
        <div
            className={`slick-arrow  slick-next`}
            onClick={onClick}
        >
            <button className='focus:outline-0'>
                <FaAngleRight className='w-auto h-auto text-gray-400 hover:text-gray-500 font-black text-4xl' />
            </button>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { onClick } = props;

    return (
        <div
            className={`slick-arrow  slick-prev`}
            onClick={onClick}
        >
            <button className='focus:outline-none'>
                <FaAngleLeft className='w-auto h-auto text-gray-400 hover:text-gray-500 font-black text-4xl' />
            </button>
        </div>
    );
}

const Relaated = ({ productCategory }) => {
    const [getProductsBySearch, { data: products, isLoading, isError }] = useGetProductsBySearchMutation();

    useEffect(() => {
        getProductsBySearch({ 'category': productCategory })
    }, [productCategory]);


    const { i18n } = useSelector(state => state.someFun);
    const [translate, setTranslate] = useState(true);

    useEffect(() => {
        if (i18n === 'en') {
            setTranslate(true)
        }
        else {
            setTranslate(false)
        }
    }, [i18n]);


    let content = null;
    if (isLoading) {
        const array1 = [1, 4, 9, 16];
        content = (
            // <div className='grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3  gap-4 '>
            array1.map((a, i) => <ProductCardLoader relPd={true} key={i} />)
            // </div>
        )
    }
    if (!isLoading && isError) {
        content = <h1>There was an error</h1>
    }
    if (!isLoading && !isError && products?.length === 0) {
        content = <h1>No products found!</h1>
    }
    if (!isLoading && !isError && products?.length > 0) {
        content = products.map((data, i) => <Product key={i} relPd={true} product={data} />)
    }

    var settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 4,
        initialSlide: 0,
        className: "grid grid-cols-2 md:grid-cols-4 sm:grid-cols-3  gap-4 ",
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <div className='related-product-styles pb-5 pt-2 over'>
            <div>
                <div className='pb-7 grid content-center justify-center text-center'>
                    <h2 className='md:text-4xl sm:text-3xl text-2xl text-bnd-1 text-center font-bold font-poppins pb-3'>{translate ? 'Related Products' : 'সংশ্লিষ্ট পণ্য'} </h2>
                    <hr className='h-px bg-bnd-1 md:w-60 sm:w-44 w-28  mx-auto' />
                </div>
                <div className='overflow-hidden'>
                    <Slider {...settings} className='span space-x-1'>
                        {content}
                    </Slider>
                </div>
            </div>
        </div>
    );
};

export default Relaated;